import { Table } from '@nimbus-ds/components';
import { CustomHeaderCell } from 'commons/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';

export function TransferListHeader() {
  const t = useTranslationCatalog('transfers.list.header');

  return (
    <Table.Head>
      <Table.Row>
        <CustomHeaderCell width="98px">{t('id')}</CustomHeaderCell>
        <CustomHeaderCell width="260px">{t('originLocation')}</CustomHeaderCell>
        <CustomHeaderCell width="260px">
          {t('destinationLocation')}
        </CustomHeaderCell>
        <CustomHeaderCell width="120px">{t('transferDate')}</CustomHeaderCell>
        <CustomHeaderCell width="124px">{t('status')}</CustomHeaderCell>
      </Table.Row>
    </Table.Head>
  );
}
